
import WordsLayoutView from './component';

export default WordsLayoutView;
